export enum Module {
  FOLIO,
  TEMPLATE,
  STORAGE_ACCOUNT,
  CUSTOM_ROLE
}
